import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import ButtonMain from '../../components/common/ButtonMain';
import Input from '../../components/common/InputField';
import InputFileUpload from '../../components/common/UploadInput';
import './style.css';
import { resetUser } from '../../store/features/loginUser';
import SelectNumberInput from '../../components/common/SelectNumberInput';
import VerificationButton from '../../components/common/verificationButton';
import { ReactComponent as Dropdown } from '../../assets/images/dropdown-arrow.svg';

function Customer(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stateName, setStateMethod] = useState({
    Website: '',
    WebsiteError: '',
    WebsiteInvalid: false,
    FormSubmitting: false,
    websiteState: false,
  });

  const [logo, setLogo] = useState(null);
  const [jobASsignRole, setJobAssignRole] = useState('1-10');
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );
  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  const {
    setSelectOnBoarding,
    setCustomerCompanyWebsite,
    setCustomerAssignRole,
    customerCompanyWebsite,
    customerAssignRole,
    setLogoUpload,
    logoUpload,
  } = props;

  useEffect(() => {
    const hasWebsite = Boolean(customerCompanyWebsite);
    setStateMethod((prev) => ({
      ...prev,
      Website: customerCompanyWebsite || '',
      websiteState: hasWebsite,
    }));
    if (customerAssignRole) {
      setJobAssignRole(customerAssignRole);
    }
    if (logoUpload instanceof File) {
      setLogo(logoUpload);
    }
  }, []);

  const validateUrl = (url) => {
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
    return urlRegex.test(url);
  };

  const handleChange = async (event) => {
    switch (event.target.name) {
    case 'Website':
      {
        const isUrlValid = validateUrl(event.target.value);
        setCustomerCompanyWebsite(event.target.value);
        if (!isUrlValid) {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            WebsiteError: 'Only URL allowed for Company Website',
            WebsiteInvalid: true,
            websiteState: false,
          });
        } else {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            WebsiteError: '',
            WebsiteInvalid: false,
            websiteState: true,
          });
        }
      }
      break;
    default:
      setStateMethod({
        ...stateName,
        [event.target.name]: event.target.value,
      });
    }
  };

  const EnableHandlerCustomer = () => {
    setCustomerCompanyWebsite(stateName.Website);
    setCustomerAssignRole(jobASsignRole);
    if (logo instanceof File) {
      setLogoUpload(logo);
    } else if (logoUpload instanceof File) {
      setLogoUpload(logoUpload);
    }
    setSelectOnBoarding(2);
  };
  const logoutHandler = () => {
    dispatch(resetUser());
    navigate('/', { replace: true });
  };
  return (
    <>
      <div className="OnBoarding-Container">
        <div className="inputDivStyle-onboarding ">
          <div className="textDiv__login">
            <p className="text__create">{t.CUSTOMER_HEADING}</p>
          </div>
          <label htmlFor="customerSelect" className="customer_label">
            {t.CUSTOMER_LOGO}
          </label>
          <InputFileUpload
            setLogo={setLogo}
            logo={logo || logoUpload}
            title={t.CUSTOMER_LOGO}
          />
          <br />
          <Input
            name="Website"
            id="Website"
            type="text"
            value={stateName.Website}
            onChange={(e) => handleChange(e)}
            error={stateName.WebsiteError}
            className={clsx(
              stateName.WebsiteInvalid ? 'input__error' : '',
              stateName.websiteState ? 'input__success' : '',
            )}
            title={t.CUSTOMER_WEBSITE}
            placeholder={t.CUSTOMER_WEBPLACEHOLDER}
          />

          <br />
          <label htmlFor="customerSelect" className="customer_label">
            {t.CUSTOMER_SELCET}
          </label>
          <SelectNumberInput
            value={jobASsignRole}
            onChange={(e) => {
              setJobAssignRole(e);
            }}
            popupIcon={<Dropdown />}
          />
          <div className="btn-class">
            <VerificationButton
              title={stateName.Website.trim()
                || jobASsignRole.trim() ? t.BTN_CONTINUE : 'Skip'}
              enable
              onClick={() => {
                EnableHandlerCustomer();
              }}
            />
            <ButtonMain
              title={t.BTN_BACK}
              className="btn__back"
              onClick={() => setSelectOnBoarding(0)}
            />
          </div>
          <p className="a__singIn">
            {t.SKIP_OB}
            <span className="b__signIn" onClick={logoutHandler}>
              {t.LOGOUT}
            </span>
          </p>
        </div>
      </div>
      <FooterTrustChat />
    </>
  );
}
Customer.propTypes = {
  setSelectOnBoarding: PropTypes.func.isRequired,
  setCustomerCompanyWebsite: PropTypes.func.isRequired,
  setCustomerAssignRole: PropTypes.func.isRequired,
  customerCompanyWebsite: PropTypes.string.isRequired,
  customerAssignRole: PropTypes.string,
  setLogoUpload: PropTypes.func.isRequired,
  logoUpload: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

Customer.defaultProps = {
  customerAssignRole: '1-10',
  logoUpload: null,
};

export default Customer;
